import { EasmScanConfigurationAssetGridView } from '../view/EasmScanConfigurationAssetGridView';
import { templateEasmScanConfigurationAssetGrid } from '../view/template';
import { EasmScanConfigurationAssetGridRepository } from '../repository/EasmScanConfigurationAssetGridRepository';
import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { EasmScanConfigurationAssetGridWebComponent } from '..';
import { EASMScanConfigurationAssetGridViewData } from '../types';
import { GridEvents } from '../../../../grid/types/common';

export class EasmScanConfigurationAssetGridController extends BaseWebComponentController {
  public component: EasmScanConfigurationAssetGridWebComponent;
  public dataRepository: EasmScanConfigurationAssetGridRepository;
  public view: EasmScanConfigurationAssetGridView;
  public viewConstructor: typeof EasmScanConfigurationAssetGridView;
  public dataRepositoryConstructor: typeof EasmScanConfigurationAssetGridRepository;

  constructor(component: EasmScanConfigurationAssetGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: EasmScanConfigurationAssetGridView,
      viewTemplate: templateEasmScanConfigurationAssetGrid,
      dataRepositoryConstructor: EasmScanConfigurationAssetGridRepository,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$gridView,
        event: GridEvents.GRID_LOADED,
        callback: this.gridLoaded,
      },
    ];
  }

  public async getDataForView(): Promise<EASMScanConfigurationAssetGridViewData> {
    const data: any = await this.dataRepository.getDataForView();
    const displayedColumns = data.views[0].displayedColumns;
    const filters = data.views[0].filters;

    return {
      allColumns: data.allColumns,
      views: data.views.map(view => {
        return {
          id: view.id,
          name: view.name,
          type: view.type,
          displayedColumns: displayedColumns,
          filters: filters,
          compactView: view.compactView,
          pageSize: view.pageSize,
        };
      }),
      defaultViewProps: data.defaultViewProps,
    };
  }

  private gridLoaded(): void {
    this.component.dispatchEvent(
      new CustomEvent(GridEvents.GRID_LOADED, {
        detail: {},
        bubbles: true,
      })
    );
  }
}
